module.exports = __webpack_public_path__ + "img/wirecard.d0b87de0.png";